import React from 'react';
import { IconLock, IconFile, IconBrandDiscord, IconCopy } from '@tabler/icons-react';

const GroupRow = ({ group, creators, onManage, onDuplicate }) => {
 const groupCreators = creators.filter(c => c.groupId === group._id);
 const assignedCount = groupCreators.length;
 const postedCount = groupCreators.filter(c =>
 ['POSTED', 'VERIFIED', 'PAID'].includes(c.deliveryStatus?.toUpperCase()) || c.tweet?.url
 ).length;
 const totalImpressions = groupCreators.reduce((sum, c) =>
 sum + (c.tweet?.metrics?.impressions || 0), 0
 );

 const handlesList = groupCreators
 .map(c => c.twitterHandle)
 .slice(0, 6)
 .join(', ');
 const moreCount = groupCreators.length > 6 ? groupCreators.length - 6 : 0;

 return (
 <div className="bg-surface-1 border border-glass-border p-3 sm:p-4 mb-3 hover:bg-glass-bg-hover">
 <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3">
 <div className="flex-1 min-w-0">
 <div className="flex items-center gap-3 mb-1">
 <div className="w-10 h-10 flex items-center justify-center font-bold text-sm flex-shrink-0 bg-accent-muted text-accent">
 {group.name.replace('Group ', '')}
 </div>
 <div className="min-w-0">
 <div className="flex items-center gap-2 flex-wrap">
 <h3 className="text-base font-semibold text-text-primary">{group.name}</h3>
 {group.status === 'active' ? (
 <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-accent-muted text-accent border border-accent/30">
 <IconLock size={12} />
 Active
 </span>
 ) : group.status === 'completed' ? (
 <span className="inline-flex items-center px-2 py-0.5 text-xs font-medium bg-accent text-white">
 Completed
 </span>
 ) : (
 <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-surface-2 text-text-secondary">
 <IconFile size={12} />
 Draft
 </span>
 )}
 {group.status === 'active' && (group.discord?.threadId || group.discord?.channelId) && (
 <span className="inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium bg-accent-muted text-accent">
 <IconBrandDiscord size={12} />
 Discord
 </span>
 )}
 </div>
 <div className="text-sm text-text-secondary mt-0.5 truncate">
 {handlesList}{moreCount > 0 && ` +${moreCount} more`}
 {groupCreators.length === 0 && 'No creators assigned'}
 </div>
 </div>
 </div>
 </div>

 <div className="flex items-center gap-3 sm:gap-6 flex-shrink-0 sm:ml-4 justify-between sm:justify-end">
 <div className="flex items-center gap-3 sm:gap-6">
 <div className="text-center">
 <div className="text-base sm:text-lg font-bold text-text-primary">
 {assignedCount}/{group.groupSize}
 </div>
 <div className="text-xs text-text-secondary">Assigned</div>
 </div>
 <div className="text-center">
 <div className="text-base sm:text-lg font-bold text-text-primary">{postedCount}</div>
 <div className="text-xs text-text-secondary">Posted</div>
 </div>
 <div className="text-center">
 <div className="text-base sm:text-lg font-bold text-text-primary">{totalImpressions.toLocaleString()}</div>
 <div className="text-xs text-text-secondary">Impr.</div>
 </div>
 </div>

 <div className="flex items-center gap-1 sm:gap-2">
 <button
 onClick={() => onDuplicate(group._id)}
 title="Duplicate group"
 className="p-2 text-text-tertiary hover:text-accent hover:bg-accent-muted min-h-[36px]"
 >
 <IconCopy size={18} />
 </button>
 <button
 onClick={() => onManage(group._id)}
 className="px-3 sm:px-5 py-2 text-sm font-medium bg-accent hover:bg-accent-hover text-white min-h-[36px]"
 >
 {group.status === 'completed' ? 'View' : 'Manage'}
 </button>
 </div>
 </div>
 </div>
 </div>
 );
};

export default GroupRow;
